import * as React from 'react';

import styles from './FatInfrastructureList.css';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IFatInfrastructureListItem } from '../../types';
import { isArrayWithItems } from '../../utils/helpers';
import { FatImageBlock } from '../FatImageBlock';
import { FatInfoBlock } from '../FatInfoBlock';

export interface IFatInfrastructureListProps {
  list: IFatInfrastructureListItem[];
  isHidden: boolean;
  onInit(): void;
}

export class FatInfrastructureList extends React.Component<IFatInfrastructureListProps> {
  public componentDidMount() {
    const { list } = this.props;
    if (isArrayWithItems(list)) {
      this.props.onInit();
    }
  }

  public render() {
    const { list, isHidden } = this.props;
    if (isHidden || !list.length) {
      return null;
    }

    return (
      <ul className={styles['container']} id={NavigationLinkTypes.Features}>
        {list.map(item => {
          const props = {
            key: `${item.title}.${item.imageUrl}`,
            ...item,
          };

          return item.displayType === 'info' ? <FatInfoBlock {...props} /> : <FatImageBlock {...props} />;
        })}
      </ul>
    );
  }
}
